export default [{
  label: '单选',
  value: 1,
},{
  label: '多选',
  value: 2,
},{
  label: '星级',
  value: 3,
},{
  label: '排序',
  value: 4,
},{
  label: '数字',
  value: 5,
},{
  label: '手机号',
  value: 6,
},{
  label: '身份证号',
  value: 7,
},{
  label: '邮箱',
  value: 8,
},{
  label: '单行文本',
  value: 9,
},{
  label: '多行文本',
  value: 10,
/* },{
  label: '图片',
  value: 11,
*/
},]
